import AreaOptions from './AreaOptions'

export default AreaOptions
